// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"7a28a40c","150":"cb59187a","453":"31bc29c5","739":"a23c3e0d"}[chunkId] + ".css";
};